import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router';
import PropTypes from 'prop-types';
import { StudentSPPDetails } from './StudentProgressDetails';
import Button from 'chameleon/ui-stack/ui/base/button';

const SPPProgressDetails = ({
  progressDetailsId,
  popoverDetails,
  subjectInfo = {},
  assignment = {},
  fromTeacherAssignmentsTable = false,
}) => {
  const {
    studentsWhoHaveNotStarted,
    studentsWhoHaveNotSubmitted,
    studentsWhoHaveSubmitted,
  } = popoverDetails;
  const viewResultsUrl =
    subjectInfo && assignment
      ? `/${subjectInfo.id}/assessments/results/${assignment.id}`
      : null;
  const progressDetails = (
    <div id={progressDetailsId} className="grid grid-cols-3 gap-x-6 py-14">
      <StudentSPPDetails
        userNumber={studentsWhoHaveNotStarted.length}
        progressType="Not Started"
        classNames="text-black bg-gray-400"
      >
        {studentsWhoHaveNotStarted}
      </StudentSPPDetails>
      <StudentSPPDetails
        userNumber={studentsWhoHaveNotSubmitted.length}
        progressType="Not Submitted"
        classNames="text-purple-700 bg-pink-200"
      >
        {studentsWhoHaveNotSubmitted}
      </StudentSPPDetails>
      <StudentSPPDetails
        userNumber={studentsWhoHaveSubmitted.length}
        progressType="Submitted"
        classNames="text-pink-200 bg-purple-700"
      >
        {studentsWhoHaveSubmitted}
      </StudentSPPDetails>
    </div>
  );
  const viewResultsLink = (
    <div className="text-right">
      <RouterLink to={viewResultsUrl}>
        <Button
          tabIndex={0}
          accessibility={{
            'aria-label': 'View Results',
          }}
          isPrimary
        >
          View Results
        </Button>
      </RouterLink>
    </div>
  );
  return (
    <Fragment>
      {progressDetails}
      {viewResultsUrl && fromTeacherAssignmentsTable && viewResultsLink}
    </Fragment>
  );
};

SPPProgressDetails.displayName = 'SPPProgressDetails';
SPPProgressDetails.defaultProps = {
  progress: {},
};
SPPProgressDetails.propTypes = {
  progress: PropTypes.shape({
    not_started: PropTypes.number,
    started: PropTypes.number,
    watched: PropTypes.number,
    total_students: PropTypes.number,
  }),
  progressDetailsId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  subjectInfo: state.subject.data,
});

export default connect(mapStateToProps)(SPPProgressDetails);
